(() => {
  const roots=()=>[...document.querySelectorAll('[data-cart-countdown]')];
  const keyFor=root=>`master-cart-countdown:${location.host}:${root.dataset.minutes||'8'}`;
  const setup=root=>{
    if(root.dataset.masterReady==='true') return; root.dataset.masterReady='true';
    const output=root.querySelector('[data-cart-countdown-time]');
    const mins=Math.max(1,Number(root.dataset.minutes||8));
    let timer=null,expires=0;
    const setExpiry=()=>{
      expires=Date.now()+mins*60000;
      if(root.dataset.persist==='true'){try{sessionStorage.setItem(keyFor(root),String(expires))}catch(_){}}
    };
    const loadExpiry=()=>{
      if(root.dataset.persist==='true'){try{expires=Number(sessionStorage.getItem(keyFor(root))||0)}catch(_){}}
      if(!expires || expires<=Date.now()) setExpiry();
    };
    const tick=()=>{
      const left=Math.max(0,expires-Date.now());
      if(left<=0){if(output)output.textContent=root.dataset.expired||'00:00';clearInterval(timer);timer=null;return;}
      const total=Math.ceil(left/1000),m=Math.floor(total/60),s=total%60;if(output)output.textContent=`${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    };
    const activate=()=>{root.hidden=false;loadExpiry();tick();if(!timer)timer=setInterval(tick,1000)};
    const deactivate=()=>{root.hidden=true;clearInterval(timer);timer=null;expires=0;try{sessionStorage.removeItem(keyFor(root))}catch(_){}};
    if(root.dataset.active==='true') activate(); else root.hidden=true;
    root._masterCountdown={activate,deactivate};
  };
  const init=scope=>scope.querySelectorAll('[data-cart-countdown]').forEach(setup);
  init(document);
  document.addEventListener('master:cart-updated',e=>{
    const active=Number(e.detail?.cart?.item_count||0)>0;
    roots().forEach(r=>active?r._masterCountdown?.activate():r._masterCountdown?.deactivate());
    document.querySelectorAll('[data-cart-social-proof]').forEach(el=>el.hidden=!active);
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
